export default class GenerateCodeResponse {
    constructor(
        public success: boolean,
        public errorMessages: string[],
    ) { }
}